<script setup lang="ts">
import { cn } from '@/lib/utils'
import {
  NavigationMenuContent,
  type NavigationMenuContentEmits,
  type NavigationMenuContentProps,
  useForwardPropsEmits,
} from 'reka-ui'
import { computed, type HTMLAttributes } from 'vue'

const props = defineProps<NavigationMenuContentProps & { class?: HTMLAttributes['class'] }>()

const emits = defineEmits<NavigationMenuContentEmits>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <NavigationMenuContent
    v-bind="forwarded"
    :class="cn(
      'bg-blue-500 left-0 top-auto w-full md:absolute md:w-auto overflow-hidden rounded-b-md rounded-tr-none rounded-tl-none border bg-popover py-1 text-popover-foreground shadow-md min-w-[200px]',
      props.class,
    )"
  >
    <slot />
  </NavigationMenuContent>
</template>
